import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../utils/sagas";
import {apiPost} from "./client";

export const usePurge = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (password) {
        yield call(apiPost, `/api/v2/user/purge`, {
            password
        });
    }, []))
};